import { HttpService } from 'src/app/services/http.service';
import { ensureProjection as registerProjection, normalizeEpsgCode } from 'src/app/features/site/site-map/utils/projection';

export { normalizeEpsgCode };

/**
 * Makes the EPSG code ("31370", 31370 or "EPSG:31370") known to proj4 and OpenLayers and resolves with its
 * canonical name ("EPSG:31370"), the one to use in `transform`. Rejects when the code is invalid or its
 * definition cannot be registered. Shares the session-wide registry of the site map.
 */
export async function ensureProjection(http: HttpService, epsg: string | number): Promise<string> {
  const code = normalizeEpsgCode(epsg);
  if (!code || !(await registerProjection(http, code))) {
    throw new Error(`Projection ${epsg} could not be registered`);
  }
  return code;
}
